import { Navigate, useLocation } from 'react-router-dom';
import { authApi } from '../api/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();

  if (!authApi.isAuthenticated()) {
    // Carry the query string over. The admin invite email links to the app
    // root with `?invite=<email>` (inviteTenantMember.ts), and `/` is behind
    // this guard — so redirecting to a bare `/login` dropped the param and
    // Login opened in password mode instead of prefilled register mode.
    return <Navigate to={`/login${location.search}`} replace />;
  }

  return <>{children}</>;
}
